<template>
  <div class="frame_around">

    <template v-if="account_receivables_list.show_data === 0">
<!--    do not show anything  -->
    </template>

    <template v-if="account_receivables_list.show_data === 1">

      <h1>
        Account Receivables
      </h1>
  <!--    <template v-if="account_receivables_list_loading">-->
  <!--      Updating-->
  <!--    </template>-->

      <template v-if="days_shop_sort === 0">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Oldest Invoice</th>
                <th style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="switch_shop_sort()">Shop Name</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_date_sort()">Last Order Date</th>

                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>

              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.days_sort_desc" v-bind:key="customer.customer_id" :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>


                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="days_shop_sort === 1">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Newst Invoice</th>
                <th style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="switch_shop_sort()">Shop Name</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_date_sort()">Last Order Date</th>
                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.days_sort_asc" v-bind:key="customer.customer_id"  :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>
                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="days_shop_sort === 2">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Days Since</th>
                <th class="assign_text_left">Shop Name</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_date_sort()">Last Order Date</th>
                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.shop_sort_asc" v-bind:key="customer.customer_id" :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>
                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="days_shop_sort === 3">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Days Since</th>
                <th style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="switch_shop_sort()">Shop Name</th>
                <th>Last Order Date</th>
                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.date_sort_desc" v-bind:key="customer.customer_id" :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>
                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="days_shop_sort === 4">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Days Since</th>
                <th style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="switch_shop_sort()">Shop Name</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_date_sort()">Last Order Date</th>
                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.unpaid_percentage_asc" v-bind:key="customer.customer_id" :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>
                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>

      <template v-if="days_shop_sort === 5">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped table-bordered table-hover table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_days_sort()">Days Since</th>
                <th style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="switch_shop_sort()">Shop Name</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_date_sort()">Last Order Date</th>
                <th class="assign_text_left">Region</th>
                <th>Total Due</th>
                <th>Total Invoice</th>
                <th style="white-space:nowrap;">Sales Rep</th>
                <th>Unpaid Invoices</th>
                <th style="cursor: pointer; text-decoration: underline" v-on:click="switch_percentage_sort()">Unpaid %</th>
                <th>Contacted</th>
                <th>Scheduled</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="customer in account_receivables_list.unpaid_percentage_desc" v-bind:key="customer.customer_id" :style="{background: background_color(customer.ar_bad_account)}">
                <td>{{customer.position}}</td>
                <td>{{customer.days_since}}</td>
                <td style="cursor: pointer; text-decoration: underline" class="assign_text_left" v-on:click="show_customer_ar_detail_page(customer.customer_id)">{{customer.customer_display_name}}</td>
                <td>{{customer.last_date}}</td>
                <td class="assign_text_left">{{customer.region}}</td>
                <td>{{customer.total_due}}</td>
                <td>{{customer.all_invoices}}</td>
                <td>{{customer.ar_sales_rep}}</td>
                <td>{{customer.total_invoices}}</td>
                <td>{{customer.unpaid_percentage}}%</td>
                <td v-if="customer.ar_contacted === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
                <td v-if="customer.ar_scheduled === 1"> <div class="yes_tag">YES</div></td><td v-else><div class="no_tag">NO</div></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      days_shop_sort: 0,
      percentage_sort: 0,
    }
  },
  computed: {
    ...mapGetters({
      account_receivables_list: 'admin/account_receivables_list',
      account_receivables_list_loading: 'admin/account_receivables_list_loading',
      ar_sort_id: 'admin/ar_sort_id',
    }),
  },
  mounted() {
    this.days_shop_sort = this.ar_sort_id;
    this.get_account_receivables_list();
  },
  methods: {
    background_color: function(background_color) {
      if(background_color === 1) {
        return '#ffc0cb';
      }
      return null;
    },
    get_account_receivables_list () {
        this.$store.dispatch('admin/getAccountReceivablesList' , {'customer_id': 0});
    },
    show_customer_ar_detail_page(customer_id) {
      this.$router.push({name: "account_receivables_detail", 'params':{customer_id: customer_id} });
    },
    switch_days_sort() {
      let days_sort = this.days_shop_sort;
      if(days_sort === 0) {
        this.days_shop_sort = 1;
        this.$store.dispatch('admin/setARSortId1');
      } else {
        this.days_shop_sort = 0;
        this.$store.dispatch('admin/setARSortId0');
      }
      if(days_sort === 1) {
        this.days_shop_sort = 0;
        this.$store.dispatch('admin/setARSortId0');
      } else {
        this.days_shop_sort = 1;
        this.$store.dispatch('admin/setARSortId1');
      }
      if(days_sort === 2) {
        this.days_shop_sort = 0;
        this.$store.dispatch('admin/setARSortId0');
      }
      if(days_sort === 3) {
        this.days_shop_sort = 0;
        this.$store.dispatch('admin/setARSortId0');
      }
    },
    switch_shop_sort() {
      this.days_shop_sort = 2;
      this.$store.dispatch('admin/setARSortId2');
    },
    switch_date_sort() {
      this.days_shop_sort = 3;
      this.$store.dispatch('admin/setARSortId3');
    },
    switch_percentage_sort() {
      if(this.days_shop_sort === 4) {
        this.days_shop_sort = 5;
        this.$store.dispatch('admin/setARSortId5');
      } else {
        this.days_shop_sort = 4;
        this.$store.dispatch('admin/setARSortId4');
      }
    },

  }
}
</script>


<style>

.text-color-red {
  color: rgb(255,0,0)
}
.text-color-green {
  color: rgb(0,255,0)
}

.assign_text_left {
  text-align: left;
}

.yes_tag {
  color: white;
  width: 48px;
  background-color: green;
  padding-top: 4px;
  padding-bottom: 3px;
  border-radius: 1px;
  border-style: hidden;
  font-size: smaller;
  font-weight: 800;
}
.no_tag {
  color: white;
  width: 48px;
  background-color: red;
  padding-top: 4px;
  padding-bottom: 3px;
  border-radius: 1px;
  border-style: hidden;
  font-size: smaller;
  font-weight: 800;
}

.frame_around {
  padding-left: 1%;
  padding-right: 1%;
}


</style>

